export default __webpack_public_path__ + "static/smileytouchfreerightplain-d16ea4a95267edb606ff28b02437df52.svg";